import React from 'react';
import './title.css'

const Titel = () => {
    return ( 
        <>
        <div className='title_div'>
            <h6 className='title_h6'>Excellence in Egyptian Legal Practice</h6>
            <h5 className='title_h5'>About Our Firm</h5>
        </div>
        </>
     );
}
 
export default Titel;